import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { Callout, Intent, Spinner, Card, Tab, Tabs, H4 } from '@blueprintjs/core';
import { executeQueryGetAuth } from 'app/utils/api';
import { formatDate } from 'app/utils';

interface Props {
    user: UserState;
    targetUser: string;
};

interface State {
    waitingOnApi: boolean;
    history: CoachingEntry[];
}

interface CoachingEntry {
    created: string;
    coachingID: string;
    viewed: number;
    user: number;
    createdBy: number;
    coaching: string;
}

export class CoachingPersonalView extends React.Component<Props, State> {

    state: State = {
        waitingOnApi: true,
        history: []
    }

    componentDidMount() {
        executeQueryGetAuth(`data/coaching/${this.props.targetUser}`, {}, this.props.user, (response) => {
            try {
                const resp = JSON.parse(response.text);

                this.setState({
                    history: resp,
                    waitingOnApi: false
                });
            }
            catch(e) {

            }
        });
    }

    renderSingleEntry = (history: any) => {
        return <Card title={formatDate(history.created)}>
            <H4>{formatDate(history.created)}</H4>
            <strong style={{display: 'block'}}>
                Your Personal Coaching:
            </strong>
            <span>
                {history.coaching}
            </span>
            {history.support ? <strong style={{display: 'block'}}>
                Feedback: {history.support} ({history.feedbackTime})
            </strong> : undefined}
        </Card>
    }

    renderEntries = () => {
        const {
            history
        } = this.state;

        let cards: any[] = [];

        for (let i = 0; i < history.length; i++) {
            const hasBeenRead = history[i].viewed === 1;
            cards.push(
                <Tab id={history[i].coachingID} title={<span style={{fontWeight: hasBeenRead ? 'normal' : 'bold'}}>{hasBeenRead ? '' : '(New) ' + formatDate(history[i].created)}</span>} panel={this.renderSingleEntry(history[i])} />
            )
        }

        return <Tabs
            animate={true}
            id="CoachingHistory"
            key={"vertical"}
            renderActiveTabPanelOnly={true}
            vertical={true}
        >
            {cards}
            <Tabs.Expander />
        </Tabs>
    }

	render() {
        const {
            waitingOnApi
        } = this.state;

        if (waitingOnApi) {
            return <Spinner />
        }

        return <span style={{display: 'block', width: '100%', margin: 'auto', marginTop: '20px'}}>
            <Callout intent={Intent.PRIMARY}>
                {this.renderEntries()}
            </Callout>
        </span>
	}
}
